import React from "react";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

function BlurLoading({ isGlobal }) {
  const { loading } = useSelector((state) => state.transferResponse);

  const showLoading =
    (!isGlobal && loading === "pending") ||
    (isGlobal && loading === "globalPending");

  if (!showLoading) return null;

  return isGlobal ? (
    <div id="diff-click-cont"></div>
  ) : (
    <div id="blurry-cont">
      <div className="loading">
        <Spinner animation="border" role="status" />
      </div>
    </div>
  );
}

export default BlurLoading;
